// Tabs block mobile dropdown (Views/Partials/blockgrid/Components/tabs.cshtml).
// Below md the tab row is swapped for a dropdown whose items are a second set of Bootstrap
// tab triggers for the same panes. Bootstrap only tracks the active trigger within each set,
// so when either set shows a pane, mark the matching trigger in the other set active too and
// put the tab's name on the dropdown button.

export function initTabsDropdowns() {
    document.querySelectorAll<HTMLElement>('.tabs-dropdown').forEach(dropdown => {
        const block = dropdown.parentElement;
        const label = dropdown.querySelector<HTMLElement>('.tabs-dropdown__label');
        if (!block || !label) {
            return;
        }

        // This block's own triggers - the dropdown's and the tab row's - not those of a Tabs
        // block nested in one of its panes.
        const triggers = Array.from(block.querySelectorAll<HTMLElement>('[data-bs-toggle="tab"]')).filter(trigger =>
            trigger.closest('.tabs-dropdown, [role="tablist"]:not(.dropdown-menu)')?.parentElement === block);

        block.addEventListener('shown.bs.tab', event => {
            const shown = event.target as HTMLElement;
            if (!triggers.includes(shown)) {
                return;
            }

            const target = shown.getAttribute('data-bs-target');
            triggers.forEach(trigger => {
                const active = trigger.getAttribute('data-bs-target') === target;
                trigger.classList.toggle('active', active);
                trigger.setAttribute('aria-selected', active ? 'true' : 'false');
                trigger.tabIndex = active ? 0 : -1;
                if (active && dropdown.contains(trigger)) {
                    label.textContent = trigger.textContent;
                }
            });
        });
    });
}
